import React, { useEffect } from 'react';
import { Alert } from '@one-thd/sui-atomic-components';
import { WarningAlertWrapper } from '../configurator/styles';

const ColorUnavailableAlert = () => {

  const warningMessage = 'Your selected color is not available in these measurements. Please select another color.';

  useEffect(() => {
    const elementLine = document.querySelector('.sui-border-warning-subtle');
    const elementIcon = document.querySelector('.sui-fill-warning-subtle');

    if (elementLine?.classList.contains('sui-border-warning-subtle')) {
      elementLine.classList.replace('sui-border-warning-subtle', 'sui-border-warning');
    }

    if (elementIcon?.classList.contains('sui-fill-warning-subtle')) {
      elementIcon.classList.replace('sui-fill-warning-subtle', 'sui-fill-warning');
    }
  }, []);

  return (
    <>
      <WarningAlertWrapper>
        <Alert
          size="large"
          status="warning"
          onClose={(el) => {
            const alertElement = el?.currentTarget?.closest('[role="alert"]');
            if (alertElement) {
              alertElement.remove();
            }
          }}
        >
          {warningMessage}
        </Alert>

      </WarningAlertWrapper>
    </>
  );
};

export default ColorUnavailableAlert;